import F from './contact-channels182.js';
import r from './contact-channels176.js';
import l$1 from './contact-channels159.js';

function m(r,e){var t=F(r,e),o=t.carrierCode,n=t.nationalNumber;if(n!==r){if(!l(r,n,e))return {nationalNumber:r};if(e.possibleLengths()&&!N(n,e))return {nationalNumber:r}}return {nationalNumber:n,carrierCode:o}}function l(r$1,e,t){return !(r(r$1,t.nationalNumberPattern())&&!r(e,t.nationalNumberPattern()))}function N(r,e){switch(l$1(r,e)){case "TOO_SHORT":case "INVALID_LENGTH":return  false;default:return  true}}

export { m as default };
//# sourceMappingURL=contact-channels185.js.map
